import { render } from "./addInfo.vue?vue&type=template&id=38fb78d8&scoped=true"
import script from "./addInfo.vue?vue&type=script&lang=js"
export * from "./addInfo.vue?vue&type=script&lang=js"

import "./addInfo.vue?vue&type=style&index=0&id=38fb78d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fb78d8"]])

export default __exports__